// Using Vue 3 reactive system
import { reactive } from 'vue';

const EventBus = reactive({
  emit(event, ...args) {
    if (this[event]) {
      this[event].forEach((callback) => callback(...args));
    }
  },
  on(event, callback) {
    if (!this[event]) {
      this[event] = [];
    }
    this[event].push(callback);
  },
  off(event, callback) {
    if (this[event]) {
      const index = this[event].indexOf(callback);
      if (index > -1) {
        this[event].splice(index, 1);
      }
    }
  },
});

export default EventBus;
